import { useEffect } from 'react';

// Render with the CSS fallback immediately; opt into the brand family only
// when a real downloaded face is available, rather than its invisible fallback.
export default function useSiteFont() {
  useEffect(() => {
    const fonts = document.fonts;
    if (!fonts || typeof fonts.load !== 'function') return undefined;

    const root = document.documentElement;
    const stylesheet = document.getElementById('site-font-stylesheet');
    let cancelled = false;
    let activated = false;

    const load = () => {
      if (cancelled || activated) return;
      const family = getComputedStyle(root).getPropertyValue('--site-brand-font').trim();
      if (!family) return;

      try {
        Promise.resolve(fonts.load(`400 1em ${family}`)).then(faces => {
          // An empty result means the stylesheet has not declared the face yet.
          if (cancelled || activated || !faces.length || faces.some(face => face.status !== 'loaded')) return;
          activated = true;
          root.classList.add('site-font-ready');
          stylesheet?.removeEventListener('load', load);

          // Warm the occasional emphasized word without delaying regular text.
          try {
            Promise.resolve(fonts.load(`italic 400 1em ${family}`, 'know')).catch(() => {});
          } catch (_) { /* Keep regular text readable if italic loading fails. */ }
        }).catch(() => {});
      } catch (_) { /* Unsupported or failed font loading keeps the CSS fallback. */ }
    };

    // Register first so a stylesheet completing during the initial attempt
    // can retry even when the first request found no declared font faces.
    stylesheet?.addEventListener('load', load);
    load();
    return () => {
      cancelled = true;
      stylesheet?.removeEventListener('load', load);
      // A successfully loaded font remains available after this hook unmounts.
    };
  }, []);
}
